/** Customer support email. Never used for sales/quotes. */
export const SUPPORT_EMAIL = "hello@carnies.dev";

/** Email link helpers — only used for support and launch notifications. */
export const mailSupport = (subject = "Customer support") =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

export const mailNotify = (subject = "Mailing list") =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

/** Social. */
export const INSTAGRAM = "https://www.instagram.com/carnies.dev/";

/** Internal routes. */
export const routes = {
  home: "/",
  terms: "/terms",
  privacy: "/privacy",
  refund: "/refund-policy",
  licence: "/licence",
  shop: "/shop",
  free: "/free",
} as const;
